import { chakra } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';

import { ComplianceApplicationProblemReason } from '../../libs/constants';
import locales from './locales';

const HELP_PAGE_URL = 'https://help.shine.fr/articles/2869225';

/**
 * The compliance module can have two variants of blocker screen.
 * One if the selected country of tax residency is not allowed.
 * And another one if foreign tax residencies are not allowed at all.
 * The only thing that differs between those two screens is one paragraph (reasonText).
 */
const ComplianceApplicationProblem = ({
  reason,
  reasonText,
}: {
  reason: ComplianceApplicationProblemReason;
  reasonText: string;
}) => {
  return (
    <>
      <ApplicationProblemImage />
      <Heading marginBottom="space-16" size="lg">
        {locales.title}
      </Heading>

      <Text variant="primary">{locales[reason].description}</Text>

      <br />

      <Text variant="primary">{reasonText}</Text>

      {reason === ComplianceApplicationProblemReason.UsCitizenship ? (
        <>
          <br />
          <Text variant="primary">{locales.footer}</Text>
        </>
      ) : null}

      <Button
        as={chakra.a}
        href={HELP_PAGE_URL}
        marginTop="space-32"
        target="_blank"
        variant="inline-primary"
      >
        {locales.findOutMoreLink}
      </Button>
    </>
  );
};

export default ComplianceApplicationProblem;
